var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings--container__width"},[(_vm.hasSubscriptionSelfService)?_c('Subscription',{attrs:{"subscriptions":_vm.subscriptions,"resellerId":255,"account":_vm.account,"userId":"self","currentSubscription":_vm.currentSubscription,"nextSubscription":_vm.nextSubscription},on:{"changed":_vm.loadData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }